import React from 'react';
import {
  Modal,
  ModalContent,
  ModalOverlay,
  Flex,
  Text,
  Button,
  Image,
} from '@chakra-ui/react';
import {Link as ReactRouterLink} from 'react-router-dom';
import {useConnectedCrmIntegration} from '../../../../hooks/api/crm';

export const PostSaveAgentModal = ({
  isOpen,
  onClose,
  agentLabel,
  isNewAgent,
}: {
  isOpen: boolean;
  onClose: () => void;
  agentLabel: string;
  isNewAgent: boolean;
}) => {
  const integration = useConnectedCrmIntegration();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="lg"
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent p={{base: 6, md: 10}} textAlign="center" borderRadius="2xl">
        <Flex direction="column" align="center" gap={6}>
          <Image src="/confetti-check.png" alt="Success" mx="auto" />
          <Text fontSize="xl">
            Success! Your {isNewAgent ? 'new ' : 'updated'} {agentLabel} is off
            to work. Now what?
          </Text>
          <Text color="kgray.300">
            Your {isNewAgent ? 'new' : 'updated'} agent may take some time to
            complete their field enrichment jobs.
          </Text>
          <Text color="kgray.300">
            In the meantime, {isNewAgent ? 'start' : 'continue'} mapping your
            {isNewAgent ? 'new' : ''} fields in CRM Field Mapping or go back to
            your list of agents.
          </Text>
          <Flex mt={4} gap={4} justifyContent="space-around" width="100%">
            <Button
              as={ReactRouterLink}
              colorScheme="kbuttonblue"
              to={`/settings/integrations/${integration?.type ?? ''}`}
            >
              {integration
                ? 'Setup CRM Field Mapping'
                : 'Setup CRM Integration'}
            </Button>
            <Button
              colorScheme="kbuttonblue"
              onClick={onClose}
              variant="outline"
            >
              Back to Agents
            </Button>
          </Flex>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
